<template>
  <b-card class="relative-position">
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <div class="d-flex justify-content-between">
        <h3>الاجتماعات</h3>
        <b-button
          variant="success"
          @click="
            $refs.meetingsModal.init({});
            isModalActive = true;
          "
          v-if="canAddTransaction"
          v-can="{ slug: $route.meta.slug, action: 'C' }"
        >
          <feather-icon icon="PlusIcon" />
          إضافة</b-button
        >
      </div>
      <div
        v-if="meetings.length > 0"
        v-can="{ slug: $route.meta.slug, action: 'S' }"
      >
        <meeting-collapse
          v-for="(item, i) in meetings"
          :key="i"
          :info="item"
          :page.sync="currentPage"
          @editClicked="openEditModal"
        />
      </div>
      <alert massage="عذراً لا يوجد نتائج لعرضها" class="w-100" v-else />
      <pagination
        v-can="{ slug: $route.meta.slug, action: 'S' }"
        v-model="currentPage"
        :total-rows="pagination.total_row"
        :per-page="pagination.per_page"
        align="end"
        class="mt-2"
      />
    </div>
    <form-modal
      v-model="isModalActive"
      :formSchema="meetingFormSchema"
      :loading="loading"
      ref="meetingsModal"
      title="معلومات الاجتماع"
      static
      size="lg"
      @confirm="onFormSubmitted"
    >
      <template #attendance_names="{ form }">
        <b-form-group label="اسماء الحضور" label-for="date" class="mb-5">
          <quill-editor v-model="form.attendance_names" 
          :options="editorOption"/>
        </b-form-group>
      </template>
    </form-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BFormGroup,
  BPagination,
  BCol,
  BRow,
} from "bootstrap-vue";
import MeetingCollapse from "../../components/MeetingCollapse.vue";
import { mapGetters } from "vuex";
import Pagination from "@/components/pagination/index.vue";
import Alert from "@/components/Alert.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import FormModal from "@/components/FormModal.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    MeetingCollapse,
    BButton,
    BFormGroup,
    BPagination,
    Pagination,
    BCol,
    BRow,
    Alert,
    LoadingOverlay,
    FormModal,
    quillEditor,
  },
  data() {
    return {
      currentPage: 1,
      isModalActive: false,
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
      meetingFormSchema: {
        title: {
          component: "FormInput",
          key: "title",
          attrs: {
            label: "رقم محضر الاجتماع",
            rules: "required",
          },
        },
        meeting_date: {
          component: "FormMask",
          key: "meeting_date",
          attrs: {
            placeholder: "YYYY-MM-DD",
            options: "date",
            raw: false,
            label: "تاريخ محضر الاجتماع",
            rules: "required",
          },
        },
        meeting_type_id: {
          component: "FormSelect",
          key: "meeting_type_id",
          attrs: {
            id: "meeting-type",
            label: "نوع الاجتماع",
            rules: "required",
            ep: "v2/selects/meeting-types",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
          },
        },
        attendance_names: {
          key: "attendance_names",
        },
        file: {
          component: "FormFileInput",
          key: "file",
          attrs: {
            label: "ملف المحضر",
            accept: "application/pdf",
            rules: this.isModalEditing ? "" : "required",
          },
        },
      },
      isModalEditing: false,
    };
  },

  methods: {
    openEditModal(meeting) {
      var toEdit = { ...meeting };
      toEdit.meeting_type_id = meeting.meetingType.id;
      delete toEdit.meetingType;
      this.$refs.meetingsModal.init(toEdit);
      this.isModalActive = true;
    },
    onFormSubmitted(form) {
      const fd = new FormData();
      for (const key in form) {
        if (Object.hasOwnProperty.call(form, key)) {
          const element = form[key];
          if (key === "file") {
            if (typeof element === "string") continue;
            else fd.append(key, element);
          } else fd.append(key, element);
        }
      }
      if (!form.id) {
        this.$store
          .dispatch("AdministrativeStatus/meeting/createMeeting", {
            fd: fd,
            page: this.currentPage,
          })
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "تمت الإضافة بنجاح",
                icon: "CheckSquareIcon",
                variant: "success",
                timeout: 3000,
              },
            });
          });
      } else {
        fd.append("_method", "PUT");
        this.$store
          .dispatch("AdministrativeStatus/meeting/ubdateMeeting", {
            fd: fd,
            page: this.currentPage,
            id: form.id,
          })
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "تم التعديل بنجاح",
                icon: "CheckSquareIcon",
                variant: "success",
                timeout: 3000,
              },
            });
          });
      }

      this.isModalActive = false;
    },
  },

  computed: {
    ...mapGetters("AdministrativeStatus/meeting", [
      "meetings",
      "loading",
      "pagination",
    ]),
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
  watch: {
    currentPage(value) {
      this.$store.dispatch("AdministrativeStatus/meeting/getMeetings", {
        page: this.currentPage,
      });
    },
  },

  created() {
    this.$store.dispatch("AdministrativeStatus/meeting/getMeetings", {
      page: this.currentPage,
    });
  },
};
</script>
